<mat-dialog-content class="px-3 py-4">

  <form #f="ngForm" (ngSubmit)="onSubmit(f)">

    <div class="row">
      <div class="col-12 col-xl-4">
        <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
          <mat-label>Document Name</mat-label>
          <input
            matInput
            placeholder="Document Name"
            [(ngModel)]="folder.name"
            name="name"
            type="text"
            #name
            required
            id="name"/>
          <mat-error *ngIf="!name.valid">
            Please enter the name of the document.
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-12 col-xl-4">
        <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
          <mat-label>Document Type</mat-label>
          <mat-select placeholder="Document Type" [(ngModel)]="folder.folder_type" name="type" required id="type">
            <mat-option *ngFor="let document_type of documentTypes" [value]="document_type">{{ document_type }}</mat-option>
          </mat-select>
          <mat-error *ngIf="!folder.folder_type">
            Please select the type of document.
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-12 col-xl-4">
        <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
          <mat-label>Document Number</mat-label>
          <input
            matInput
            placeholder="Document Number"
            #folder_number
            id="folder_number"
            [(ngModel)]="folder.folder_number"
            name="folder_number"
            type="text"/>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-xl-4">
        <app-timezone-select [timezoneInput]="selectedTimezone" (timezoneOutput)="getOutputTimezone($event)"></app-timezone-select>
      </div>
      <div class="col-12 col-xl-3">
        <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
          <mat-label>Expiry Date</mat-label>
          <input
            matInput
            [matDatepicker]="picker"
            placeholder="Expiry Date"
            readonly
            (click)="picker.open()"
            [(ngModel)]="date"
            name="date"
            id="date"
            [min]="now"/>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker disabled="false"></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="col-12 col-xl-5">
        <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic" *ngIf="show_document_visibility">
          <mat-label>Document Visibility</mat-label>
          <mat-select placeholder="Document Visibility" [(ngModel)]="folder.visibility" name="visibility" required id="visibility">
            <mat-option value="Private">Private - Only viewable to person they belong to</mat-option>
            <mat-option value="Group">Group - Administrators and person they belong to</mat-option>
            <mat-option value="Public">Public - Everyone and person they belong to</mat-option>
          </mat-select>
          <mat-error *ngIf="!folder.visibility">
            Please select the level of privacy.
          </mat-error>
        </mat-form-field>
      </div>
    </div>

  </form>

</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="p-3">
  <button
    mat-raised-button
    class="my-2 ml-1 mr-2"
    [disabled]="!f.valid || inProgress"
    color="primary"
    (click)="onSubmit(f)"
    id="save">
    <mat-icon>save</mat-icon>
    Save
  </button>

  <button
    mat-raised-button
    color="secondary"
    (click)="onRemoveExpiryDate()"
    class="my-2 ml-1 mr-2"
    [disabled]="!folder.expiry && !date">
    <mat-icon>calendar_today</mat-icon>
    Remove Expiry Date
  </button>

  <app-files-selector
    (selected)="newFiles = $event"
    [selectedFilesCount]="newFiles?.length"
    class="my-2 ml-1 mr-2">
  </app-files-selector>

  <button
    mat-raised-button
    class="my-2 ml-1 mr-2"
    (click)="onRemoveFiles()"
    color="secondary"
    [matBadge]="'' + (folder.files?.length || 0)"
    [disabled]="!folder.files?.length">
    <mat-icon>open_in_browser</mat-icon>
    Manage Files
  </button>

  <button
    type="button"
    color="warn"
    mat-icon-button
    [disabled]="!folder.id"
    class="dialog-remove-button my-2 ml-auto mr-1"
    (click)="onRemove()"
    *ngIf="permissions?.canDelete">
    <mat-icon>delete</mat-icon>
  </button>
</mat-dialog-actions>

